
import { useState, useEffect } from 'react';
import eventDinnerImg from '@/assets/event-dinner.png';
import eventPitchImg from '@/assets/event-pitch.png';
import eventCultureImg from '@/assets/event-culture.png';
import eventWorkshopImg from '@/assets/event-workshop.png';
import eventSportsImg from '@/assets/event-sports.png';
import eventResearchImg from '@/assets/event-research.png';
import eventBoatImg from '@/assets/event-boat.png';
import eventCocktailImg from '@/assets/event-cocktail.png';
import eventDinnerPast1Img from '@/assets/event-dinner-past1.png';
import eventDinnerPast2Img from '@/assets/event-dinner-past2.png';
import eventDinnerPast3Img from '@/assets/event-dinner-past3.png';
import eventSummerPast1Img from '@/assets/event-summer-past1.png';
import eventSummerPast2Img from '@/assets/event-summer-past2.png';

interface EventsProps {
  onNavigate: (section: string) => void;
}

export default function Events({ onNavigate }: EventsProps) {
  const [selectedEvent, setSelectedEvent] = useState<{ title: string; images: string[] } | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Keyboard navigation
  useEffect(() => {
    if (!selectedEvent) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setSelectedEvent(null);
      } else if (e.key === 'ArrowLeft' && currentImageIndex > 0) {
        setCurrentImageIndex(currentImageIndex - 1);
      } else if (e.key === 'ArrowRight' && currentImageIndex < selectedEvent.images.length - 1) {
        setCurrentImageIndex(currentImageIndex + 1);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedEvent, currentImageIndex]);

  const upcomingEvents = [
    {
      date: "2026",
      title: "Annual Dinner",
      location: "Istanbul",
      description: "Join us for an elegant evening of networking and celebration"
    }
/*    {
      date: "April 8, 2025",
      title: "Tech Innovation Panel",
      location: "Koç University, Istanbul",
      description: "Cambridge alumni discuss the future of technology and AI"
    },
    {
      date: "May 20, 2025",
      title: "Mentorship Workshop",
      location: "Bilkent University, Ankara",
      description: "Professional development and career guidance session"
    },
    {
      date: "June 12, 2025",
      title: "Social Impact Summit",
      location: "Sabancı University, Istanbul",
      description: "Exploring ways to create positive change in our communities"
    }*/
  ];

  const pastHighlights = [
    {
      title: "2025 Annual Dinner",
      images: [eventDinnerImg]
    },
    {
      title: "British Council's Social Impact Award 2021 - Nilüfer Özsoy",
      images: [eventPitchImg]
    },
/*    {
      title: "Cultural Heritage Tour",
      images: [eventCultureImg]
    },
    {
      title: "Career Development Workshop",
      images: [eventWorkshopImg]
    },
    {
      title: "Alumni Sports Day",
      images: [eventSportsImg]
    },
    {
      title: "Research Symposium",
      images: [eventResearchImg]
    },*/
    {
      title: "Bosphorus Boat Tour",
      images: [eventBoatImg,eventWorkshopImg]
    },
    {
      title: "Networking Cocktail Evening",
      images: [eventCocktailImg]
    },
    {
      title: "Past Annual Dinners",
      images: [eventDinnerPast1Img, eventDinnerPast2Img, eventDinnerPast3Img]
    },
    {
      title: "Summer Social Events",
      images: [eventSummerPast1Img, eventSummerPast2Img]
    }
  ];

  return (
    <section id="events" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Events &amp; Activities
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Connect, learn, and grow with fellow Cambridge alumni through our diverse range of events
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <h3 
              className="text-2xl font-bold text-gray-900 mb-8"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Upcoming Events
            </h3>
            <div className="space-y-6">
              {upcomingEvents.map((event, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="text-sm text-teal-600 font-medium mb-2">{event.date}</div>
                      <h4 className="text-xl font-bold text-gray-900 mb-2">{event.title}</h4>
                      <p className="text-gray-600 mb-2">
                        <i className="ri-map-pin-line mr-2"></i>
                        {event.location}
                      </p>
                      <p className="text-gray-700 text-sm">{event.description}</p>
                    </div>
                    <button
                      onClick={() => onNavigate('join')}
                      className="ml-4 bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Register Interest
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 
              className="text-2xl font-bold text-gray-900 mb-8"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Past Highlights
            </h3>
            <div className="grid grid-cols-2 gap-4 mb-6">
              {pastHighlights.map((highlight, index) => (
                <div key={index} className="relative group cursor-pointer" onClick={() => { setSelectedEvent(highlight); setCurrentImageIndex(0); }}>
                  <img
                    src={highlight.images[0]}
                    alt={highlight.title}
                    className="w-full h-32 object-cover rounded-lg shadow-md group-hover:shadow-lg transition-shadow"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
                    <span className="text-white text-sm font-medium text-center px-2">{highlight.title}</span>
                  </div>
                  {highlight.images.length > 1 && (
                    <div className="absolute top-2 right-2 bg-black/60 text-white text-xs px-2 py-1 rounded">
                      {highlight.images.length} photos
                    </div>
                  )}
                </div>
              ))}
            </div>
            <p className="text-gray-600 text-sm">
              Stay connected with our community by subscribing to our newsletter for event updates and exclusive opportunities.
            </p>
          </div>
        </div>

        {selectedEvent && (
          <div
            className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedEvent(null)}
          >
            <div className="relative max-w-5xl w-full max-h-full" onClick={(e) => e.stopPropagation()}>
              <img
                src={selectedEvent.images[currentImageIndex]}
                alt={selectedEvent.title}
                className="max-w-full max-h-[80vh] mx-auto object-contain rounded-lg"
              />

              {/* Close Button */}
              <button
                onClick={() => setSelectedEvent(null)}
                className="absolute top-4 right-4 text-white hover:text-gray-300 cursor-pointer bg-black/50 rounded-full w-10 h-10 flex items-center justify-center"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>

              {/* Image Counter */}
              {selectedEvent.images.length > 1 && (
                <div className="absolute top-4 left-4 bg-black/60 text-white px-3 py-1 rounded-full text-sm">
                  {currentImageIndex + 1} / {selectedEvent.images.length}
                </div>
              )}

              {/* Previous Button */}
              {selectedEvent.images.length > 1 && currentImageIndex > 0 && (
                <button
                  onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                  className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 cursor-pointer bg-black/50 rounded-full w-12 h-12 flex items-center justify-center"
                >
                  <i className="ri-arrow-left-s-line text-3xl"></i>
                </button>
              )}

              {/* Next Button */}
              {selectedEvent.images.length > 1 && currentImageIndex < selectedEvent.images.length - 1 && (
                <button
                  onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 cursor-pointer bg-black/50 rounded-full w-12 h-12 flex items-center justify-center"
                >
                  <i className="ri-arrow-right-s-line text-3xl"></i>
                </button>
              )}

              {/* Event Title */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/60 text-white px-4 py-2 rounded-lg text-center max-w-2xl">
                <h4 className="font-medium">{selectedEvent.title}</h4>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
